import dayjs from 'dayjs'

export const daysOfTheWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'] as const

export const calculatePatternScheduleStartDate = (dayOfTheWeek: number) => {
  const currentDay = dayjs().day()
  const daysToSubtract = currentDay <= dayOfTheWeek ? 7 - dayOfTheWeek + currentDay : currentDay - dayOfTheWeek
  return dayjs().subtract(daysToSubtract % 7, 'days')
}

export const dateToOffsetDay = (date?: string | null) => (date ? dayjs(date).day() : undefined)
export const offsetDayToDate = calculatePatternScheduleStartDate
